// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AffiliateRouteImport } from './routes/affiliate'
import { Route as ConciergeRouteImport } from './routes/concierge'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CopyRouteImport } from './routes/copy'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MyRoutesRouteImport } from './routes/my-routes'
import { Route as OwnerRouteImport } from './routes/owner'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PartnerTermsRouteImport } from './routes/partner-terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProRouteImport } from './routes/pro'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedCreditsRouteImport } from './routes/_authenticated/credits'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as ConciergeIndexRouteImport } from './routes/concierge.index'
import { Route as ConciergeIdRouteImport } from './routes/concierge.$id'
import { Route as ConciergeAdminRouteImport } from './routes/concierge.admin'
import { Route as ConciergeAgentRouteImport } from './routes/concierge.agent'
import { Route as OriginalsIndexRouteImport } from './routes/originals.index'
import { Route as OriginalsSlugRouteImport } from './routes/originals.$slug'
import { Route as RSlugRouteImport } from './routes/r.$slug'
import { Route as ProRSlugRouteImport } from './routes/pro.r.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AffiliateRoute = AffiliateRouteImport.update({
            id: '/affiliate',path: '/affiliate',getParentRoute: () => rootRouteImport
          })
const ConciergeRoute = ConciergeRouteImport.update({
            id: '/concierge',path: '/concierge',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CopyRoute = CopyRouteImport.update({
            id: '/copy',path: '/copy',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MyRoutesRoute = MyRoutesRouteImport.update({
            id: '/my-routes',path: '/my-routes',getParentRoute: () => rootRouteImport
          })
const OwnerRoute = OwnerRouteImport.update({
            id: '/owner',path: '/owner',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const PartnerTermsRoute = PartnerTermsRouteImport.update({
            id: '/partner-terms',path: '/partner-terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProRoute = ProRouteImport.update({
            id: '/pro',path: '/pro',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedCreditsRoute = AuthenticatedCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const ConciergeIndexRoute = ConciergeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ConciergeRoute
          })
const ConciergeIdRoute = ConciergeIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => ConciergeRoute
          })
const ConciergeAdminRoute = ConciergeAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => ConciergeRoute
          })
const ConciergeAgentRoute = ConciergeAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => ConciergeRoute
          })
const OriginalsIndexRoute = OriginalsIndexRouteImport.update({
            id: '/originals/',path: '/originals/',getParentRoute: () => rootRouteImport
          })
const OriginalsSlugRoute = OriginalsSlugRouteImport.update({
            id: '/originals/$slug',path: '/originals/$slug',getParentRoute: () => rootRouteImport
          })
const RSlugRoute = RSlugRouteImport.update({
            id: '/r/$slug',path: '/r/$slug',getParentRoute: () => rootRouteImport
          })
const ProRSlugRoute = ProRSlugRouteImport.update({
            id: '/r/$slug',path: '/r/$slug',getParentRoute: () => ProRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedCreditsRoute: AuthenticatedCreditsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const ConciergeRouteChildren = {
  ConciergeIdRoute: ConciergeIdRoute,ConciergeAdminRoute: ConciergeAdminRoute,ConciergeAgentRoute: ConciergeAgentRoute,ConciergeIndexRoute: ConciergeIndexRoute
}

const ConciergeRouteWithChildren = ConciergeRoute._addFileChildren(ConciergeRouteChildren)




const ProRouteChildren = {
  ProRSlugRoute: ProRSlugRoute
}

const ProRouteWithChildren = ProRoute._addFileChildren(ProRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AccountRoute: AccountRoute,AdminRoute: AdminRoute,AffiliateRoute: AffiliateRoute,ConciergeRoute: ConciergeRouteWithChildren,CookiesRoute: CookiesRoute,CopyRoute: CopyRoute,LegalRoute: LegalRoute,LoginRoute: LoginRoute,MyRoutesRoute: MyRoutesRoute,OwnerRoute: OwnerRoute,PartnerRoute: PartnerRoute,PartnerTermsRoute: PartnerTermsRoute,PrivacyRoute: PrivacyRoute,ProRoute: ProRouteWithChildren,TermsRoute: TermsRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutReturnRoute: CheckoutReturnRoute,OriginalsSlugRoute: OriginalsSlugRoute,RSlugRoute: RSlugRoute,OriginalsIndexRoute: OriginalsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)